import React from 'react';
import Accordion from 'components/Accordion';
import { IProps } from './types';
import _ from 'lodash';
import { ServiceFAQ } from 'bff/models/info';

const QuestionAnswer: React.FC<IProps> = (props) => {
  /**
   * @description 產生 Q & A 內容區塊
  */
  const handleCreactContent = () => {
    if (!props.qaInfos || props.qaInfos.length === 0) return;
    const splitChar = ' ';
    const childs = _.map(props.qaInfos, (qa:ServiceFAQ, index:number) => {
      const titleArray = qa.Q.split(splitChar);
      return (
        <Accordion.Item key={index}>
          <Accordion.Header
            title={
              <div className="question-answer__item-title">
                <span className="question-answer__index">{titleArray[0]}</span>
                <span>{titleArray[1]}</span>
              </div>
            }
          />
          <Accordion.Content>
            {
              _.map(qa.A, (str:string, strIndex:number) => (
                React.cloneElement(
                  <>
                    {str} <br />
                  </>, { key: strIndex })
              ))
            }
          </Accordion.Content>
        </Accordion.Item>
      );
    });

    return (
      <Accordion>
        {childs}
      </Accordion>
    );
  };

  return (
    <div className="question-answer">
      <div className="template-container">
        <div className="template-content">
          <div className="question-answer__title-section">
            <div className="question-answer__title">{props.title}</div>
          </div>
          <div className="question-answer__content">
            {handleCreactContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionAnswer;
